module.exports = __webpack_public_path__ + "img/three.24a0afa2.png";